<template>
  <div>
    <a-row :gutter="24" style="margin: 2vh 0;">
      <a-col :md="12" :sm="24" style="margin-bottom: 2vh;">
        <a-input-search placeholder="输入文件名进行搜索" enterButton/>
      </a-col>
      <a-col :md="8" :sm="24">
        <a-button type="primary">上传PKG</a-button>
        <a-button type="danger" style="margin-left: 5px">批量删除</a-button>
      </a-col>
    </a-row>

    <a-table
      :rowSelection="rowSelection"
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="page.content"
      :pagination="pagination"
      :loading="loading">
      <template slot="name" slot-scope="text, record">
        <router-link to="#">{{ record.filename }}</router-link>
      </template>
      <template slot="md5" slot-scope="text">
        <a-tooltip>
          <template slot="title">
            {{ text }}
          </template>
          {{ text.length>7?text.substring(0,7)+'...':text }}
        </a-tooltip>
      </template>
      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="download(record)">下载</a>
      </span>
    </a-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      columns: [
        {
          title: '文件名',
          dataIndex: 'filename',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: 'MD5',
          dataIndex: 'md5',
          scopedSlots: { customRender: 'md5' }
        },
        {
          title: '大小',
          dataIndex: 'size'
        },
        {
          title: '对应机芯',
          dataIndex: 'core'
        },
        {
          title: '备注',
          dataIndex: 'note'
        },
        {
          title: '上传时间',
          dataIndex: 'gmtCreate'
        },
        {
          title: '最近使用',
          dataIndex: 'lastUse'
        },
        {
          title: '操作',
          dataIndex: 'action',
          // width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      page: {
        content: [{
          id: '1',
          filename: '2019022001.pkg',
          md5: '926cc51f26997e7313c1d81456230968',
          size: '56.18MB',
          core: '5507',
          soft: '...MT5507_V9.00029',
          note: '5507升级-18年第五版',
          creatorName: '管理员',
          gmtCreate: '2018-12-08 10:31:55',
          lastUse: '酒店电视 2578 等5台终端'
        }, {
          id: '2',
          filename: '多媒体广告发布系统1007A.pkg',
          md5: '6d6730eee30715cb3faa5c7cf8e5a6c7',
          size: '72.31MB',
          core: '5507',
          soft: '...MT5507_V9.00029',
          note: '-',
          creator: '管理员',
          gmtCreate: '2018-12-24 12:00:02',
          lastUse: '无'
        }, {
          id: '3',
          filename: 'e30715cb3faa5c7c.pkg',
          md5: 'a39aa711dae09647997a234a39017e6d',
          size: '101.0MB',
          core: 'V551',
          soft: '...MT5507_V9.00029',
          note: 'V551 旧固件存档',
          creator: '管理员',
          gmtCreate: '2019-01-02 17:13:40',
          lastUse: '酒店电视 2580 等1台终端'
        }],
        empty: false,
        first: true,
        last: true,
        number: 1,
        numberOfElements: 1,
        size: 1,
        sort: {},
        totalElements: 1,
        totalPages: 1
      },
      pagination: {
        current: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      }
    }
  },

  computed: {
    rowSelection () {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
        }
      }
    }
  },

  methods: {
    download (record) {
    }
  }
}
</script>

<style scoped>

</style>
